import config from 'config';
import axios from 'axios';
import UserFlagsService from './user_flags_service';
import FileSaver from "file-saver";

const ROOT = config.API_BASE_URL;

class AssetsService {
  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}assets${params}`).then((data) => {
        resolve({ assets: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(assetId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}assets/${assetId}`).then((data) => {
        resolve({ asset: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(asset) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}assets`, asset).then((data) => {
        resolve({ asset: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static update(asset) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}assets/${asset.id}`, asset).then((data) => {
        resolve({ asset: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getImage(assetId, fileName, image) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}assets/${assetId}/images/${fileName}`, image).then((data) => {
        resolve({ assetImage: data.data, response: data });
      }).catch((err) => {
        // img does not exist
        reject(err);
      });
    });
  }

  static replaceImage(assetId, file, imageId) {
    return new Promise((resolve, reject) => {
      const uploadData = new FormData();
      uploadData.append('file', file);

      axios.post(`${ROOT}assets/${assetId}/images/replace/${imageId}`, uploadData).then((data) => {
        resolve({ assetImage: data.data, response: data });
      }).catch((err) => {
        // img does not exist
        reject(err);
      });
    });
  }

  static deleteImage(assetId, fileName, imageId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}assets/${assetId}/images/${fileName}/${imageId}`).then((data) => {
        resolve({ assetImage: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static uploadImage(assetId, file, fileName) {
    return new Promise((resolve, reject) => {
      const uploadData = new FormData();
      uploadData.append('file', file);

      axios.post(`${ROOT}assets/${assetId}/images/`, uploadData).then((data) => {
        resolve({ assetImage: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAssetReceivedDataByAssetMeasure(timeConstraint, endAtDate, assetId, deviceSerialNumber, deviceDataTypeToken) {
    return new Promise((resolve, reject) => {
      const query = `timeConstraint=${timeConstraint}&endAtDate=${endAtDate}${UserFlagsService.getUserFlagsAsURLParams(true)}`;
      axios.get(`${ROOT}reports/assets/${assetId}/device/${deviceSerialNumber}/measure/${deviceDataTypeToken}?${query}`).then((data) => {
        resolve({ readingsData: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllAssetReport(startAtDate, endAtDate, groupingId, excludeDeviceReport) {
    return new Promise((resolve, reject) => {
      const query = `groupingId=${groupingId}&startAtDate=${startAtDate}&endAtDate=${endAtDate}&excludeDeviceReport=${excludeDeviceReport}${UserFlagsService.getUserFlagsAsURLParams(true)}`;
      axios.get(`${ROOT}reports/all-assets-report?${query}`).then((data) => {
        resolve({ allDeviceReport: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllAssetReportCSV(startAtDate, endAtDate, groupingId, excludeDeviceReport) {
    return new Promise((resolve, reject) => {
      const query = `groupingId=${groupingId}&startAtDate=${startAtDate}&endAtDate=${endAtDate}&excludeDeviceReport=${excludeDeviceReport}${UserFlagsService.getUserFlagsAsURLParams(true)}`;
      axios.post(`${ROOT}reports/all-assets-csv-report?${query}`).then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        FileSaver.saveAs(blob, 'all-assets-report.csv');
        resolve();
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAllForGrouping(groupingId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}assets/list?filterByGroupingId=${groupingId}`).then((data) => {
        resolve({ assets: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAssetDetailReport(startAtDate, endAtDate, assetId) {
    return new Promise((resolve, reject) => {
      const query = `assetId=${assetId}&startAtDate=${startAtDate}&endAtDate=${endAtDate}${UserFlagsService.getUserFlagsAsURLParams(true)}`;
      axios.get(`${ROOT}reports/asset-detail-report?${query}`).then((data) => {
        resolve({ detailReportData: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getMeasureComparisonReport(startAtDate, endAtDate, measurementIds) {
    return new Promise((resolve, reject) => {
      const query = `startAtDate=${startAtDate}&endAtDate=${endAtDate}&measurementIds=${measurementIds}${UserFlagsService.getUserFlagsAsURLParams(true)}`;
      axios.get(`${ROOT}reports/measurement-comparison-report?${query}`).then((data) => {
        resolve({ report: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }  

  static getAssetDetailReportCSV(startAtDate, endAtDate, assetId) {
    return new Promise((resolve, reject) => {
      const query = `assetId=${assetId}&startAtDate=${startAtDate}&endAtDate=${endAtDate}${UserFlagsService.getUserFlagsAsURLParams(true)}`;
      axios.post(`${ROOT}reports/asset-detail-csv-report?${query}`).then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        FileSaver.saveAs(blob, 'report.csv');
        resolve();
      }).catch((err) => {
        reject(err);
      });
    });
  }  
}

export default AssetsService;
